<template>
  <div>
    <swiper v-if="indexBanners.length > 0" :options="fullSwiperOption" ref="indexSwiper" class="swiper">
        <swiper-slide v-for="banner in indexBanners" :key="banner.id">
            <div class="index-swiper-banner">
              <img :src="banner.mobileImg" alt="">
            </div>
        </swiper-slide>
    </swiper>
    <div class="wrap">
        <section id="room-block" class="section">
            <ul class="my_ul_style">
              <li v-for="room_type in room_types" :key="room_type.id">
                <router-link :to="{ name: 'room', params: {id: parseInt(room_type.id)} }">
                  <span class="my_span_1_style">
                      {{ room_type.room_type }}
                  </span>
                  <span class="my_span_2_style">
                      深入<br>了解
                  </span>
                </router-link>
              </li>
            </ul>
        </section>
        <section id="intro-block" class="section">
            <div class="row">
                <div class="col col2">
                    <div class="box">
                        <div class="left">
                            <div class="name">最新<br>消息</div>
                            <p>News</p>
                        </div>
                        <div class="text">
                            <ul>
                                <li v-for="news in news_list" :key="news.id">
                                  <router-link :to="{name: 'newsPage', params: {id: news.id}}">
                                    <span class="date">
                                      {{news.enable_time}}
                                    </span>
                                    <span class="txt">
                                      {{news.title}}
                                    </span>
                                  </router-link>
                                </li>
                            </ul>
                            <div class="link-block text-right">
                              <router-link :to="{name: 'news'}" class="link">
                                更多新訊
                              </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col2">
                    <div class="box">
                        <div class="left">
                            <div class="name">大樓<br>介紹</div>
                            <p>About</p>
                        </div>
                        <div class="text">
                            <p>
                              {{building_list.content}}
                            </p>
                            <div class="link-block text-right">
                                <router-link :to="{name: 'about'}" class="link">
                                  深入了解
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col2">
                    <div class="box">
                        <div class="left">
                            <div class="name">房型<br>介紹</div>
                            <p>Rooms</p>
                        </div>
                        <div class="text">
                            <p>
                              {{room_content.roomContent}}
                            </p>
                            <div class="link-block text-right">
                                <router-link :to="{ name: 'room', params: {id: parseInt(room_content.id)} }" class="link">
                                  深入了解
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col2">
                    <div class="box">
                        <div class="left">
                            <div class="name">公共<br>設施</div>
                            <p>Facility</p>
                        </div>
                        <div class="text">
                            <ul>
                                <li v-for="equipment in equipment_list" :key="equipment.id">
                                  <router-link :to="{name: 'equipment'}">
                                    <span class="txt">
                                      {{equipment.title}}
                                    </span>
                                  </router-link>
                                </li>
                            </ul>
                            <div class="link-block text-right">
                              <router-link :to="{name: 'equipment'}" class="link">
                                更多設施
                              </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col2">
                    <div class="box">
                        <div class="left">
                            <div class="name">周遭<br>環境</div>
                            <p>Around</p>
                        </div>
                        <div class="text">
                            <p>
								{{environment_list.content}}
							</p>
                            <div class="link-block text-right">
                              <router-link :to="{name: 'location'}" class="link">
                                深入了解
                              </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col2">
                    <div class="box">
                        <div class="left">
                            <div class="name">承租<br>須知</div>
                            <p>Notice</p>
                        </div>
                        <div class="text">
                            <p>
								{{notice_list.content}}
							</p>
                            <div class="link-block text-right">
                              <router-link :to="{name: 'notice'}" class="link">
                                深入了解
                              </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="link-block" class="section">
            <div class="row">
                <div class="col col2">
                    <router-link :to="{name: 'sign'}" class="link-item" :style="{backgroundImage: 'url(' + require('@/assets/images/bg1.png') + ')' }">
                        <div class="text">
                            <i class="icon">
                              <img src="@/assets/images/icon_paper.svg" alt="租約審閱">
                            </i>
                            <div class="txt">
								租約審閱
							</div>
                        </div>
                    </router-link>
                </div>
                <div class="col col2">
                    <router-link :to="{name: 'connection'}" class="link-item" :style="{backgroundImage: 'url(' + require('@/assets/images/bg2.png') + ')' }">
                        <div class="text">
                            <i class="icon">
								<img src="@/assets/images/icon_contact.svg" alt="聯絡我們">
							</i>
                            <div class="txt">
								聯絡我們
							</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </section>
    </div>
  </div>
</template>

<script>

export default {
    name: 'Index',
    data () {
        return {
          fullSwiperOption: {
            loop: false,
            pagination: {
              el: '.swiper-pagination'
            },
            effect: 'fade',
            autoplay: {
              delay: 4000,
              disableOnInteraction: false
            },
            speed: 7000
          },
          indexBanners: [
            {
              id:0,
              mobileImg: require("@/assets/images/banner1.png")
            },
            {
              id:1,
              mobileImg: require("@/assets/images/banner2.png")
            },
            {
              id:2,
              mobileImg: require("@/assets/images/banner3.png")
            }
          ],
          room_types: '',
          room_content: '',
          news_list: '',
          building_list: '',
          equipment_list: '',
          environment_list: '',
          notice_list: ''
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'IndexList');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
              console.log(response.data.error_this);
            } else {
              const get_type = response.data.room_type;
              this.room_types = get_type;
              const get_room_content = response.data.roomContent;
              this.room_content = get_room_content;
              const get_news_list = response.data.news_list;
              this.news_list = get_news_list;
              const get_building_list = response.data.building_list;
              this.building_list = get_building_list;
              const get_equipment_list = response.data.equipment_list;
              this.equipment_list = get_equipment_list;
              const get_environment_list = response.data.environment_list;
              this.environment_list = get_environment_list;
              const get_notice_list = response.data.notice_list;
              this.notice_list = get_notice_list;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    mounted: function() {

    }
};
</script>

<style>
#room-block .my_ul_style{
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
}
#room-block .my_ul_style li{
	flex: 0 0 20%;
	margin: 10px;
}
@media (max-width: 960px) {
	#room-block .my_ul_style li{
		flex: 0 0 40%;
	}
}
@media (max-width: 576px) {
	#room-block .my_ul_style li{
		flex: 1 0 40%;
	}
}
#room-block .my_ul_style li a{
  	display: flex;
}
#room-block .my_ul_style li a:hover {
  	color: unset;
}
#room-block .my_ul_style li .my_span_1_style,
#room-block .my_ul_style li .my_span_2_style{
	display: flex;
	justify-content: center;
	align-items: center;
    padding: 20px 5px;
}
@media (max-width: 630px) {
    #room-block .my_ul_style li .my_span_1_style,
    #room-block .my_ul_style li .my_span_2_style{
        padding: 10px;
    }
}
#room-block .my_ul_style li .my_span_1_style{
	flex: 3;
	letter-spacing: 5px;
}
#room-block .my_ul_style li .my_span_2_style{
	flex: 1;
	background-color: #b28146;
}
</style>
